import React, { useRef } from "react";
import { FaCog } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import {
  MdControlPoint,
  MdDelete,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import deleteitem from "../../../components/Images/deleteitem.svg";
import edititem from "../../../components/Images/edititem.svg";
// import { jsPDF } from "jspdf";
// import * as XLSX from "xlsx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { CSVLink } from "react-csv";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { toast } from "react-toastify";
import { RxReload } from "react-icons/rx";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IoClose } from 'react-icons/io5';
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";


function ManageTranslation(props) {

  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const [datatranslatelanguage, setDataTranslatelanguage] = useState([]);
  const [defaulttranslatelanguage, setDefaultTranslatelanguage] = useState('');
  const [loading, setLoading] = useState(true);
  const [validationMessagename, setValidationMessagename] = useState("");
  const [validationMessagecode, setValidationMessagecode] = useState("");
  const [validationMessageslug, setValidationMessageslug] = useState("");
  const [isValidationHiddenname, setIsValidationHiddenname] = useState(true);
  const [isValidationHiddencode, setIsValidationHiddencode] = useState(true);
  const [isValidationHiddenslug, setIsValidationHiddenslug] = useState(true);
  const [isDefaultLangChecked, setIsDefaultLangChecked] = useState(false);
  const nameInputRef = useRef(null);
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filter, setFilter] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)

  const actionFormatter = (data, row) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <span>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </span>
        </span>
        <div className="editdropdown-menu">
          <Link to={`/edit-translate-language/${row?.id}`}>
            <IconEditFigma styled={{ width: "24px", height: "24px" }} />
            <span className="theme-text-color">
              <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
            </span>
          </Link>

          <div
            onClick={() =>
              openModalvideolanguage(row?.id)
            }
            className="commonActionPadding"
          >
            <IconDeleteFigma styled={{ width: "24px", height: "24px" }} />
            <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
          </div>
        </div>
      </div>
    );
  };


  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const translateLanguages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "manage-translation" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/translate-language/index`,
        { headers: headers }
      );
      setFilteredData(response?.data?.Language);
      setDataTranslatelanguage(response?.data?.Language);
      setDefaultTranslatelanguage(response?.data?.site_default_language)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  const columns = useMemo(() => [
    {
      dataField: 'name',
      text: 'Name',
      formatter: (cell, row) => {
        const rowCode = row.code?.trim().toLowerCase();
        const defaultLang = defaulttranslatelanguage?.trim().toLowerCase();
        const isDefaultLang = rowCode && defaultLang && rowCode === defaultLang;
        return (
          <>
            <a className="translate p-2">{cell?.length > 15 ? `${cell.slice(0, 15)}...` : cell}</a>
            {isDefaultLang && <span className="theme-text-color"> (Default Language)</span>}
          </>
        );
      },
    },
    {
      dataField: 'code',
      text: 'Short Code',
      formatter: (cell) => {
        const shortCode = cell?.length > 15 ? `${cell.slice(0, 15)}...` : cell;
        return <span title={cell}>{shortCode}</span>;
      },
    },
    {
      dataField: 'action',
      text: 'Action',
      formatter: actionFormatter,
    },
  ], [defaulttranslatelanguage]);

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: datatranslatelanguage.length },
    ],
  });

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDelete(allIds);
      } else {
        setItemToDelete([]);
      }
    },
    style: { width: '50px' },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };


  const handleFilterChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    const filteredResults = datatranslatelanguage?.filter((item) =>
      ["name", "code"].some(
        (property) =>
          typeof item[property] === "string" &&
          item[property].toLowerCase().includes(searchTerm)
      )
    );
    setFilteredData(filteredResults);
  };

  const exportHeaders = [
    { label: "ID", key: "id" },
    { label: "LANGUAGE", key: "name" },
    { label: "SHORT CODE", key: "code" },
  ];

  const conditionalGeneratePDF = async (get) => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    doc.text("LANGUAGE SUBTITLE LIST ", 10, 10);
    const columns = ["S.NO", "ID", "LANGUAGE", "SHORT CODE"];
    const allDataPDF = datatranslatelanguage.map((item, index) => [
      index + 1,
      item?.id,
      item?.name,
      item?.code,
    ]);
    const filterPDF = filteredData.map((item, index) => [
      index + 1,
      item?.id,
      item?.name,
      item?.code,
    ]);

    doc.autoTable({
      startY: 20,
      head: [columns],
      body: get == 1 ? allDataPDF : filterPDF,
    });
    doc.save("TRANSLATE-LANGUAGE-LIST.pdf");
  };

  const generateXLSX = async (get) => {
    const XLSX = await import("xlsx");
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(
        get === 1 ? datatranslatelanguage : filteredData
      );
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, "TRANSLATE-LANGUAGE-LIST.xlsx");
  };

  const handleClear = () => {
    translateLanguages();
    setFilter("");
  };

  const reloadAction = () => {
    setLoading(true);
    setWithOutRefresh(prev => !prev)
  }

  useEffect(async () => {
    translateLanguages();
  }, [withOutRefresh]);
  const [addLanguage, setAddLanguage] = useState({
    name: "", code: "", active: "", slug: "",
    site_default_language: ""
  });

  useEffect(() => {
    setIsDefaultLangChecked(addLanguage?.code === defaulttranslatelanguage);
  }, [addLanguage?.code, defaulttranslatelanguage]);

  const [active, setActive] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddLanguage((prevAddLanguage) => ({
      ...prevAddLanguage,
      [name]: value,
    }));
    setValidationMessagename("");
    setIsValidationHiddenname(true);
    setValidationMessagecode("");
    setIsValidationHiddencode(true);
    setValidationMessageslug("");
    setIsValidationHiddenslug(true);
    setAddLanguage({ ...addLanguage, title: e.target.value });
    setAddLanguage({ ...addLanguage, [e.target.name]: e.target.value });
    if (e.target.checked === true) {
      setActive({ ...active, [e.target.name]: 1 });
    } else {
      setActive({ ...active, [e.target.name]: 0 });
    }
  };



  const handleBlurtitle = () => {
    if (!addLanguage?.slug) {
      generateSlug(addLanguage?.name);
    }
  };

  const generateSlug = (name) => {
    const slug = slugGenerator(name)
    setAddLanguage((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      if (!addLanguage?.slug) {
        generateSlug(addLanguage?.name);
      }
    }
  };


  const handleBlurTitleEdit = () => {
    generateSlug(addLanguage?.slug);
  };



  const openModal = () => {
    setModelClose(true);
  };

  const closeModal = () => {
    setModelClose(!closeModal);
    setSelectAll(false);
    setItemToDelete([]);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };


  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  let firstApiStatus = false;
  let resultapi = null;

  async function saveTranslatelanguages() {
    let focusInputRef = null;

    if (addLanguage?.name === "") {
      setValidationMessagename("Name cannot be empty.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }
    else if (addLanguage?.name.trim().length < 3) {
      setValidationMessagename("Name must be at least 3 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }
    else if (addLanguage?.name.trim().length > 100) {
      setValidationMessagename("Name must not exceed 100 characters.");
      setIsValidationHiddenname(false);
      focusInputRef = nameInputRef;
    }
    if (addLanguage?.code === "") {
      setValidationMessagecode("Code cannot be empty.");
      setIsValidationHiddencode(false);
      focusInputRef = nameInputRef;
    }
    else if (addLanguage?.code.trim().length > 8) {
      setValidationMessagecode("Code must not exceed 8 characters.");
      setIsValidationHiddencode(false);
      focusInputRef = nameInputRef;
    }
    if (addLanguage?.slug === "") {
      setValidationMessageslug("Slug cannot be empty.");
      setIsValidationHiddenslug(false);
      focusInputRef = nameInputRef;
    }
    else if (addLanguage?.slug.trim().length < 3) {
      setValidationMessageslug("Slug must be at least 3 characters.");
      setIsValidationHiddenslug(false);
      focusInputRef = nameInputRef;
    }
    else if (addLanguage?.slug.trim().length > 100) {
      setValidationMessageslug("Slug must not exceed 100 characters.");
      setIsValidationHiddenslug(false);
      focusInputRef = nameInputRef;
    }
    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    const formData = {
      name: addLanguage?.name,
      code: addLanguage?.code,
      slug: addLanguage?.slug,
      active: addLanguage?.active == "on" ? 1 : 0,
      ...(isDefaultLangChecked && { site_default_language: addLanguage?.code }), // ✅ Only set if checked
    };
    setProcessing(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/translate-language/store`,
        formData,
        { headers: headers }
      );
      if (response?.data?.status) {
        toast.success(response?.data?.message)
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message)
      setProcessing(false);
      setShowOverlay(false);
    }

  };

  const navigate = useNavigate()
  const updateLanguage = (a) => {
    navigate(`/edit-translate-language/${a}`)
  }

  const [itemToDeletevideolanguage, setItemToDeletevideolanguage] = useState(null);
  const [successMessagevideolanguage, setSuccessMessagevideolanguage] = useState("");
  const [isConfirmationOpenLanguage, setIsConfirmationOpenLanguage] =
    useState(false);

  const openModalvideolanguage = (id) => {
    setItemToDeletevideolanguage(id);
    setSuccessMessagevideolanguage("");
  };

  const closeModalvideolanguage = () => {
    setItemToDeletevideolanguage(null);
  };
  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };


  const deleteLanguages = (id) => {
    setIsDeleting(true);
    axios
      .delete(`${process.env.REACT_APP_Baseurl}/admin/translate-language/delete/${id}`, {
        headers: headers,
      })
      .then((response) => {
        if (response.data.status == true) {
          var responseData = response.data;
          toast.success(responseData?.message)
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          if (responseData === false) {
            var resultError = responseData;
          }
        }
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };


  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    setIsDeleting(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_Baseurl}/admin/translate-language/multi-delete`,
        {
          headers: headers,
          data: { id: [...itemToDelete] },
        }
      );
      const result = response?.data;

      if (result?.status) {
        setWithOutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setItemToDelete([]);
      } else {
        toast.error(result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Delete error:", err);
      const errorMessage = err?.response?.data?.message || "Error deleting items";
      toast.error(errorMessage);
    } finally {
      setShowOverlay(false);
      setIsDeleting(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsDefaultLangChecked(checked);
    if (checked) {
      setDefaultTranslatelanguage(addLanguage?.code || "");
      setItemToDeletevideolanguage(addLanguage?.id || null);
    } else {
      setItemToDeletevideolanguage(null);
    }

  };

  const defaultLanguageObject = datatranslatelanguage.find(lang => lang.code === defaulttranslatelanguage);
  useEffect(() => {
    const modalEl = document.getElementById('exampleModal');
    const handleModalHide = () => {
      setValidationMessagename("");
      setValidationMessageslug("");
      setValidationMessagecode("");
      setAddLanguage({ name: "", slug: "", code: "" });
    };
    if (modalEl) {
      modalEl.addEventListener('hide.bs.modal', handleModalHide);
    }
    return () => {
      if (modalEl) {
        modalEl.removeEventListener('hide.bs.modal', handleModalHide);
      }
    };
  }, []);
  return (
    <>
      <div
        className={`modal ${itemToDeletevideolanguage !== null ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: itemToDeletevideolanguage !== null ? "block" : "none",
        }}
        id="exampleModalDelete"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header theme-border-bottom-secondary">
              <MessageBox text={"Confirm Deletion"} classname="modal-title theme-text-color admin-modal-title fw-bold" />
              <button type="button" id="closeModelIcon" className='bg-transparent theme-text-color' onClick={closeModalvideolanguage} ><IoClose fill='currentColor' style={{ width: "25px", height: "25px" }} /></button>
            </div>
            <div className="modal-body">
              {successMessagevideolanguage ? (
                <div className="alert alert-success" role="alert">
                  {successMessagevideolanguage}
                </div>
              ) : (
                <p>Are you sure you want to delete this item?</p>
              )}
            </div>
            <div className="modal-footer gap-3 border-0">
              {successMessagevideolanguage ? (
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                  onClick={closeModalvideolanguage}
                >
                  Close
                </button>
              ) : (
                <>
                  <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2" onClick={closeModalvideolanguage} id="closeModal"><MessageBox text="Cancel" /> </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    onClick={() => deleteLanguages(itemToDeletevideolanguage)}
                    disabled={isDeleting}
                    className="warningColorBg theme-button-text-color admin-button-text rounded-3 py-2 px-3 d-inline-flex align-items-center justify-content-center gap-2"
                  >
                    {isDeleting ? (
                      <div className="custom-loading mx-auto"></div>
                    ) : (
                      <MessageBox text="Delete" />
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>


      <div className=" m-0 p-0">
        <div className="">
          <div className="row">
            {/* <div className="col-md-3">
              <h4 className="admin-title mb-0 theme-text-color text-md-start"> <MessageBox text={labelDisplay?.[9]?.title} classname="theme-text-color" /> <span className="admin-sub-title theme-text-color ms-2 ">( {filteredData?.length} <MessageBox text='results found' classname="theme-text-color" />   )</span> </h4>
            </div> */}
            {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} buttonSubmitLoading={isDeleting} />}
            <div className="row admin-section-title">
              <div className="col-md-8">
                <h4 className="admin-title mb-0 theme-text-color text-md-start"> <MessageBox text={labelDisplay?.[9]?.title} classname="theme-text-color" /> <span className="admin-sub-title theme-text-color ms-2 ">( {filteredData?.length} <MessageBox text='results found' classname="theme-text-color" />   )</span> </h4>
              </div>
              <div className="col-md-4 mt-3 mt-md-0" align="right">
                {itemToDelete?.length > 0 && (
                  <button
                    className="btn warningColorBg theme-button-text-color  d-inline-flex fw-bold mb-3"
                    onClick={openModal} id="deleteActionButton"
                  >
                    <MdDelete className="exportIcon " />
                    Delete
                  </button>
                )}
                <button
                  type="button"
                  className="admin-title ms-3 rounded-2 d-inline-flex align-items-center button-bg-color theme-button-text-color  text-decoration-hover  py-2 px-3"
                  id="navigationLinkForAddPage"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  <MdControlPoint className="me-2 exportIcon " style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text " text={"Add Language"} />
                </button>
              </div>
            </div>

            <div className="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog ">
                <div className="modal-content theme-bg-color">
                  <div className="modal-header">
                    <h5
                      className="modal-title"
                      id="exampleModalLabel"
                    >
                      {labelDisplay?.[5]?.title}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body">
                    <form>
                      <div className="form-group">
                        <MessageLabel text={labelDisplay?.[0]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" placeHolder={"Enter name"} value={addLanguage?.name} onChange={handleChange} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} ref={nameInputRef} error={validationMessagename} />
                      </div>
                      <div className="form-group">
                        <MessageLabel text={"Slug"} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="slug" placeHolder={"Enter slug"} value={addLanguage?.slug} onChange={handleChange} onBlur={handleBlurTitleEdit} ref={nameInputRef} error={validationMessageslug} />
                      </div>
                      <div className="form-group ">
                        <MessageLabel text={"Short Code"} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="code" placeHolder={"Enter code"} value={addLanguage?.code} onChange={handleChange} ref={nameInputRef} error={validationMessagecode} />
                      </div>
                      <div className="p-1">
                        <h6 className="mb-3" >{labelDisplay?.[8]?.title}</h6>

                        <div className="d-flex justify-content-between ">
                          <div className="col-6 col-md-6 pe-2">
                            <MessageLabel text={labelDisplay?.[6]?.title} />
                          </div>
                          <div className="col-6 col-md-6 ps-2 text-end">
                            <label class="switch mt-2">
                              <input type="checkbox" name="active" onChange={handleChange}
                                defaultChecked={active?.active === 1 ? true : false}
                                checked={active?.active === 1 ? true : false} />
                              <span
                                className="slider round"
                                name="active"
                                onChange={handleChange}
                                value={active?.active === 1 ? "1" : "0"}
                              ></span>
                            </label>
                          </div>
                        </div>
                        <div className="d-flex justify-content-between ">
                          <div className="col-6 col-md-6 pe-2">
                            <MessageLabel text={labelDisplay?.[7]?.title} />
                          </div>
                          <div className="col-6 col-md-6 ps-2 text-end">
                            <label className="switch">
                              <input
                                name="site_default_language"
                                id="site_default_language"
                                onChange={handleCheckboxChange}
                                checked={isDefaultLangChecked}
                                type="checkbox"
                                disabled={!addLanguage?.code}
                              />
                              <span
                                className="slider round"
                                name="site_default_language"
                                onChange={handleCheckboxChange}
                                value={
                                  defaulttranslatelanguage === addLanguage.code
                                    ? "1"
                                    : "0"
                                }
                              ></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">


                    <button type="submit"
                      className="btn btn-primary"
                      onClick={saveTranslatelanguages}

                    >
                      {labelDisplay?.[2]?.title}
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="container-fluid section ">
            <div className="iq-card mt-4 theme-bg-color">
              <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                <div className="filterContainer ">
                  <input
                    type="text"
                    placeholder="Search"
                    className="filter form-control theme-bg-color"
                    value={filter}
                    onChange={handleFilterChange}
                  />
                  {filter.length > 0 && (
                    <button
                      type="button"
                      className="closeBtn"
                      onClick={handleClear}
                    >
                      <i className="fa fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="btn-group">
                  <button id="reloadButton" className={`bg-transparent custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color }`} onClick={reloadAction}>
                    <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                    <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                  </button>
                  <div className="dropdown d-block ">
                    <button
                      className="btn btn-success dropdown-toggle d-flex"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="fw-bolder">Export All</span>
                      <img src={ExportIcon} className="ms-2 exportIcon" />
                    </button>
                    <ul
                      className="dropdown-menu theme-text-color cursor-pointer"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li className="dropdown-item">
                        <CSVLink
                          headers={exportHeaders}
                          data={datatranslatelanguage}
                          className="text-dark d-block"
                          filename="TRANSLATE-LANGUAGE-LIST.csv"
                        >
                          CSV
                        </CSVLink>
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={() => {
                          conditionalGeneratePDF(1);
                        }}
                      >
                        PDF
                      </li>
                      <li
                        className="dropdown-item"
                        onClick={() => {
                          generateXLSX(1);
                        }}
                      >
                        XLSX
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bootstrapTable">
                {loading && (
                  <div style={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.6)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10,
                  }}><Defaultloadinggif />
                  </div>
                )}
                {defaulttranslatelanguage && (
                  <BootstrapTable keyField="id" data={filteredData} columns={columns} pagination={pagination} className="no-border-table theme-bg-color"
                    noDataIndication={<div className="noRecord">{loading ? (<label> {" "}<Response_Loading_processing></Response_Loading_processing>Loading...</label>) : (filteredData?.length <= 0 && (<p>No Translate Languages Available.!</p>))}</div>} hover headerClasses="custom-header" selectRow={selectRow} selectAll={selectAll}
                  />
                )}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default ManageTranslation;

